import React from "react";

import { Table } from "antd";

import styles from "./styles.module.css";
import QuantityComponent from "../../../../helper/ReusableComponents/QuantityComponent/QuantityComponent";
import { useBandLogic } from "../hooks";

const BandComponent = ({ data, onQtyChange }) => {
  const { musicians, vocalists } = useBandLogic(data, onQtyChange);

  const musiciansColumns = [
    {
      title: "Musicians",
      dataIndex: "name",
      key: "name",
    },
    {
      title: "Qty.",
      dataIndex: "default",
      key: "default",
      align: "center",
      render: (text, record) => (
        <QuantityComponent
          id={record.positionId}
          name="musicians"
          data={record}
          bandType={record.type}
          min={record.min}
          max={record.max}
          qty={record.default}
          handleQtyChange={onQtyChange}
        />
      ),
    },
  ];

  const vocalistsColumns = [
    {
      title: "Vocalists",
      dataIndex: "name",
      key: "name",
    },
    {
      title: "Qty.",
      dataIndex: "default",
      key: "default",
      align: "center",
      render: (text, record) => (
        <QuantityComponent
          id={record.positionId}
          name="vocalists"
          data={record}
          bandType={record.type}
          min={record.min}
          max={record.max}
          qty={record.default}
          handleQtyChange={onQtyChange}
        />
      ),
    },
  ];

  return (
    <div className="row">
      <Table
        className={`col-md-6 ${styles.bandConfig_band_table}`}
        dataSource={musicians}
        columns={musiciansColumns}
        pagination={false}
      />
      <Table
        className={`col-md-6 ${styles.bandConfig_band_table}`}
        dataSource={vocalists}
        columns={vocalistsColumns}
        pagination={false}
      />
    </div>
  );
};

export default BandComponent;
